
import React from 'react';
import Layout from '@/components/Layout/Layout';
import EnergyConverter from '@/components/UnitConverter/EnergyConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const EnergyConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Energy Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between various energy units, from joules to calories to kilowatt-hours.
          </p>
        </div>
        
        <div className="mb-8">
          <EnergyConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Energy Converter</h2>
          <p>
            Our energy converter tool enables you to convert between different units of energy used 
            in physics, nutrition, electricity, and other fields. Energy is the capacity to do work and 
            exists in various forms like electrical, thermal, chemical, nuclear, and mechanical energy.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Energy Unit Conversions</h3>
          <p>
            Some of the most frequently used energy conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between joules and calories (physics and nutrition)</li>
            <li>Converting kilowatt-hours to joules (electricity consumption)</li>
            <li>Converting BTUs to other units (heating and cooling)</li>
            <li>Converting electron-volts to joules (atomic and nuclear physics)</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Energy Converter</h3>
          <p>
            Using our energy converter is simple:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the energy unit you're converting from</li>
            <li>Select the energy unit you want to convert to</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <p className="mt-6">
            The energy converter supports a comprehensive range of units, including joules (J), kilojoules (kJ), 
            calories (cal), kilocalories (kcal or food calories), watt-hours (Wh), kilowatt-hours (kWh), 
            British Thermal Units (BTU), electronvolts (eV), and many more. Whether you're analyzing 
            nutritional information, calculating electricity costs, or working on physics problems, 
            our converter provides accurate conversions between all common energy units.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default EnergyConverterPage;
